import { GQLCharBlock } from "graphql/generated-types";
import { slugify } from "utils/helpers";

const CharBlock = ({ block }: { block: GQLCharBlock }) => {
	return (
		<h3 id={slugify(block.value)} className="text-20px lg:text-28px mt-6 first:mt-0">
			{block.value}
		</h3>
	);
};

export default CharBlock;
